
import { useEntitlements } from 'context/plan'

export const useMerchSurfaceVisible = (): boolean => {
  const { superuser } = useEntitlements()
  return superuser
}
